export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"
    >
      <div className="absolute inset-0 overflow-hidden opacity-[0.06] pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-400"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-400"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-5 tracking-wide whitespace-nowrap">
              香蕉视频 · 糖豆视频 · 小蓝视频 · 蓝莓视频
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              密桃视频 — 高清影视聚合观影平台
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-medium font-heading mb-6">
              全集免费在线观看，不缓冲流畅体验
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-8">
              密桃视频是国内领先的影视资源聚合平台，汇聚香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门平台的高清电影电视剧大全。全站资源免费在线观看，免注册即点即看，多线路智能调度确保不缓冲体验。
              每日同步更新最新影视内容，覆盖动作、悬疑、爱情、科幻、喜剧等全品类题材，致力成为您最值得信赖的一站式观影入口。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">内容同步</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-secondary-500">免注册</div>
                <div className="text-xs text-foreground-500 mt-1">即点即看</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                探索热门内容
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg border-2 border-primary-200 text-primary-600 font-medium text-sm hover:bg-primary-50 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                了解特色优势
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden bg-background-200/50 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20projector%20and%20movie%20reels%20on%20warm%20wooden%20table%2C%20soft%20ambient%20lighting%2C%20vintage%20cinema%20aesthetic%20with%20modern%20twist%2C%20cozy%20home%20theater%20atmosphere%2C%20rich%20warm%20golden%20and%20amber%20tones%2C%20professional%20product%20photography%2C%20elegant%20composition%2C%20film%20posters%20in%20background%20softly%20blurred&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="密桃视频高清影视聚合平台 - 香蕉视频糖豆视频小蓝视频蓝莓视频在线观看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="px-2.5 py-1 rounded-md bg-background-50/90 text-foreground-800 text-xs font-medium whitespace-nowrap">
                  4K超清
                </span>
                <span className="px-2.5 py-1 rounded-md bg-background-50/90 text-foreground-800 text-xs font-medium whitespace-nowrap">
                  即点即播
                </span>
                <span className="px-2.5 py-1 rounded-md bg-background-50/90 text-foreground-800 text-xs font-medium whitespace-nowrap">
                  不缓冲
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}